<template>
    <div class="main-container">
        <div id="loading-container" class="loading-container" v-if="isLoaderActive">
            <Loader class="loader"></Loader>
        </div>
        <div class="content-container" v-if="!loading">
            <Title v-if="['guidedTourEntry'].indexOf(contentType) < 0" :title="entry.fields.title"></Title>
            <Title v-if="contentType === 'guidedTourEntry'" :title="entry.fields.title" :background-color="'#6a71aa'" :text-color="'#F5F5F5'"></Title>
            <div class="row center-xs">
                <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
                    <agile v-if="entry && entry.fields.images" ref="carousel"
                           :autoplay="true"
                           :fade="true"
                           :speed="1000"
                           :navButtons="entry.fields.images.length > 1"
                           :dots="entry.fields.images.length > 1">
                        <div class="slide" v-for="image in entry.fields.images" :key="image.sys.id">
                            <img :src="image.fields.file.url" />
                        </div>
                    </agile>
                </div>
            </div>
            <div class="row center-xs title">
                <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">
                    <div class="text-body" :class="{'align-center': ['service', 'portfolio'].indexOf(contentType) >= 0}">
                        <div v-for="(node, j) in entry.fields.body.content" :key="j">
                            <h3 v-if="node.nodeType === 'heading-3'">
                                {{node.content[0].value}}
                            </h3>
                            <p v-if="node.nodeType === 'paragraph'">
                              <a v-for="(paragraph, l) in node.content" :key="l">
                                <a :class="{'bold': paragraph.marks.filter(m => m.type === 'bold').length > 0}" >{{paragraph.value}}</a>
                              </a>
                            </p>
                            <p class="accent" v-if="node.nodeType === 'unordered-list' && ['portfolio', 'service'].indexOf(contentType) >= 0">
                                {{node.content[0].content[0].content[0].value}}
                            </p>
                            <p v-else-if="node.nodeType === 'unordered-list'">
                                - {{node.content[0].content[0].content[0].value}}
                            </p>
                            <div v-if="node.nodeType === 'ordered-list' && contentType === 'guidedTourEntry'">
                                <div v-for="(line, k) in node.content" :key="k" class="row schedule-line">
                                    <div class="col-xs-2 bold">{{line.content[0].content[0].value}}</div>
                                    <div class="col-xs-10">{{line.content[0].content[1] != null ? line.content[0].content[1].value : ''}}</div>
                                </div>
                            </div>
                            <div class="mini-separator" v-if="node.nodeType === 'hr'"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="contentType === 'guidedTourEntry'" class="row center-xs">
                <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 contact-button">
                    <button :class="{'active': contactForm}" v-on:click="toggleContactForm()">INSCREVA-SE AQUI ATRAVÉS DO NOSSO EMAIL</button>
                </div>
            </div>
            <div v-if="contentType === 'guidedTourEntry'">
                <div class="row center-xs" id="contact-form">
                    <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 mobile-padded__evenly">
                        <ContactForm
                                :inputBackground="'#FFFFFF'"
                                :subject="'Visitas Guiadas - ' + entry.fields.title">
                        </ContactForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "../generic/Title";
    import * as contentHelper from "../../helpers/content.helper";
    import { VueAgile } from 'vue-agile'
    import Loader from "../generic/Loader";
    import anime from "animejs";
    import ContactForm from "../generic/ContactForm";

    export default {
        name: "DetailPage",
        components: {ContactForm, Loader, Title, agile: VueAgile },
        data() {
            return {
                entry: null,
                contentType: null,
                isLoaderActive: true,
                loading: true,
                contactForm: false,
                settings: {
                    lazyLoad: "ondemand",
                    dots: true,
                    edgeFriction: 0.35,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        },
        watch: {
            '$route.params.id': function () {
                this.contactForm = false;
                this.loadPage();
            }
        },
        beforeMount() {
            this.loadPage();
        },
        methods: {
            loadPage() {
                this.showLoader().then( () => this.fetchData());
            },
            fetchData() {
                this.loading = true;

                contentHelper.client.getEntry(this.$route.params.id)
                    .then(entry => {
                        this.entry = entry;
                        this.contentType = this.entry.sys.contentType.sys.id;
                        this.loading = false;
                        setTimeout(() => this.hideLoader(), 500);
                    });
            },
            getAsset(id) {
                return this.entry.includes.Asset.find(asset => asset.sys.id === id);
            },
            showLoader() {
                this.isLoaderActive = true;
                const element = document.querySelector("#loading-container");

                return anime({
                    targets: element,
                    opacity: 1,
                    duration: 300,
                    easing: 'easeOutQuad'
                }).finished;
            },
            hideLoader() {
                const element = document.querySelector("#loading-container");

                anime({
                    targets: element,
                    opacity: this.loading ? 1 : 0,
                    duration: 500,
                    easing: 'easeOutQuad'
                }).finished.then(() => { this.isLoaderActive = false });
            },
            toggleContactForm() {
                const element = document.querySelector("#contact-form");

                if (this.contactForm) {
                    element.setAttribute("style", "height: 33em;");
                }

                this.contactForm = !this.contactForm;

                anime({
                    targets: element,
                    height: this.contactForm ? '33em' : 0,
                    duration: 300,
                    easing: 'easeOutQuad'
                }).finished.then(() => {
                    if (this.contactForm) {
                        element.setAttribute("style", "height: 100%;");
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .title {
        margin-bottom: 2em;
    }

    .separator {
        background-color: $primary;
        height: 0.4em;
        width: 2.4em;
        display: inline-block;
        margin-bottom: 0.8em;
    }

    .mini-separator {
        background-color: $primary;
        height: 0.15em;
        width: 0.5em;
        display: inline-block;
    }

    .text-body {
        font-family: "Merriweather", serif;
        font-style: italic;
        margin-top: 2em;
        text-align: justify;
        h2 {
            text-align: center;
        }

        h3 {
            color: $primary;
            font-weight: 600;
            text-align: justify;
            margin-top: 2em;
        }
    }

    p.accent {
        color: $primary;
        font-weight: 600;
    }

    .schedule-line {
        margin-bottom: 1em;
    }

    .align-center {
        text-align: center;
    }

    .loading-container {
        position: absolute;
        opacity: 1;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: $primary;
        z-index: 98;

        .loader {
            position: relative;
            top: 50%;
        }
    }

    @media only screen and (max-width: 767px) {
        .loading-container {
            margin-top: $mobile-bar-height;
            margin-bottom: -30%;

            .loader {
                top: 30%;
            }
        }
    }

    .contact-button {
        margin-top: 3.5em;
        button {
            height: 3.5em;
            border: 0;
            width: 100%;
            background: $primary;
            color: $bgcolor-grey;
            text-transform: uppercase;
            font-size: x-small;
            letter-spacing: 0.1em;
            font-weight: 600;

            &:hover {
                background: $bgcolor-grey;
                color: $primary;
            }
        }

        button.active {
            background: $bgcolor-grey;
            color: $primary;

            &:hover {
                background: $primary;
                color: $bgcolor-grey;
            }
        }

    }

    #contact-form {
        margin-top: 2em;
        width: 100%;
        height: 0em;
        overflow: hidden;
        background-color: $bgcolor-grey;
    }

</style>
